module.exports = __webpack_public_path__ + "CSS/main.css";